// domain bazlı footer yazısı map'i
const DOMAIN_FOOTER_MAP = {
  'www.sctp.com.tr': 'Copyright © 2022 Real Lojistik',
  'sctp.com.tr': 'Copyright © 2022 Real Lojistik',
  'bigu.birlesikgumrukleme.com.tr': 'Copyright © 2022 Birleşik Gümrükleme',
  localhost: 'Copyright © 2022 Birleşik Gümrükleme',
  '127.0.0.1': 'Copyright © 2022 Birleşik Gümrükleme',
  default: 'Copyright © 2022 Birleşik Gümrükleme',
};

export default DOMAIN_FOOTER_MAP;
